/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ForeignDevExUser } from './ForeignDevExUser';
import type { StudyAnalysisSegment } from './StudyAnalysisSegment';
import type { StudyParticipation } from './StudyParticipation';
import type { StudyPrompt } from './StudyPrompt';

/**
 * Study metadata with response overview.
 */
export type InternalStudy = {
    name: string;
    ref: string;
    lastStudyRef?: string;
    /**
     * * `DRAFT` - DRAFT
     * * `OPEN` - OPEN
     * * `CLOSED` - CLOSED
     * * `DELETED` - DELETED
     */
    status: InternalStudy.status;
    /**
     * * `D` - D
     * * `A` - A
     * * `O` - O
     * * `H` - H
     */
    type: InternalStudy.type;
    /**
     * Notes on the objective of the study - to help contextualize the results
     */
    notes?: string;
    /**
     * An optional custom welcome message to display to the user when they start the study
     */
    welcomeMessage?: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    openDate?: string | null;
    closeDate?: string | null;
    companyName: string;
    flags: Array<string>;
    prompts: Array<StudyPrompt>;
    analysisSegments: Array<StudyAnalysisSegment>;
    createdBy?: ForeignDevExUser;
    readonly lastUpdated: string;
    readonly options: Record<string, any>;
    sequenceRef?: string;
    readonly responseCount: number;
    /**
     * Configurable number of expected responses for a study. Null if it hasn't been configured yet.
     */
    targetResponses?: number | null;
    readonly sentAt: string | null;
    /**
     * Send automatic reminders for a survey.
     */
    enableScheduledReminders?: boolean;
    /**
     * If provided, the date this survey will automatically be closed.
     */
    scheduledCloseDate?: string | null;
    /**
     * Return the scheduling data for this survey if available.
     */
    readonly schedule: Array<Record<string, any>>;
    readonly distributionMethod: InternalStudy.distributionMethod;
    /**
     * Calculate the DevEx index by averaging all topic-level scores.
     */
    readonly index: number | null;
    readonly expectedResponseCount: number;
    /**
     * Return the emails of possible targets of this survey.
     */
    readonly targets: Array<string>;
    readonly participation: StudyParticipation;
};

export namespace InternalStudy {

    /**
     * * `DRAFT` - DRAFT
     * * `OPEN` - OPEN
     * * `CLOSED` - CLOSED
     * * `DELETED` - DELETED
     */
    export enum status {
        DRAFT = 'DRAFT',
        OPEN = 'OPEN',
        CLOSED = 'CLOSED',
        DELETED = 'DELETED',
    }

    /**
     * * `D` - D
     * * `A` - A
     * * `O` - O
     * * `H` - H
     */
    export enum type {
        D = 'D',
        A = 'A',
        O = 'O',
        H = 'H',
    }

    export enum distributionMethod {
        SLACK = 'SLACK',
        MANUAL = 'MANUAL',
        MSTEAMS = 'MSTEAMS',
    }


}

